export const TYPE_LABELS = {
  recharge: "Recharge",
  debit: "Message",
  refund: "Refund",
  adjustment: "Adjustment",
  hold: "Hold",
  hold_capture: "Hold capture",
  hold_release: "Hold release",
};

export const CATEGORY_LABELS = {
  marketing: "Marketing",
  marketing_lite: "Marketing Lite",
  utility: "Utility",
  authentication: "Authentication",
  service: "Session / Service",
};

const CREDIT_TYPES = ["recharge", "refund", "hold_release"];

/** Amounts are stored unsigned. Sign comes from type, or from adjustment `sign` (+1 credit / −1 debit). */
export const isCredit = (type, meta, sign) => {
  if (sign != null && Number.isFinite(Number(sign))) return Number(sign) > 0;
  if (CREDIT_TYPES.includes(type)) return true;
  if (type === "adjustment" && meta?.sign != null) return Number(meta.sign) > 0;
  return false;
};

export function parseMeta(meta) {
  if (!meta) return null;
  if (typeof meta === "object") return meta;
  try {
    return JSON.parse(meta);
  } catch (_) {
    return null;
  }
}

export function ymd(d) {
  const x = d instanceof Date ? d : new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function defaultSpendRange(days = 30) {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - days);
  return { from: ymd(from), to: ymd(to) };
}

export function txnTitle(type, meta, resolved) {
  if (type === "recharge") return "Money added";
  if (type === "refund") return "Refund — failed messages";
  if (type === "hold") return meta?.campaign_name || meta?.name ? `Hold — ${meta.campaign_name || meta.name}` : "Hold";
  if (type === "hold_capture") return meta?.campaign_name || meta?.name ? `Hold capture — ${meta.campaign_name || meta.name}` : "Hold capture";
  if (type === "hold_release") return "Hold released";
  if (type === "adjustment") return "Adjustment";
  if (type === "debit") {
    const cat = CATEGORY_LABELS[resolved?.category || meta?.category] || resolved?.category || meta?.category;
    return cat ? `Message — ${cat}` : "Message";
  }
  return TYPE_LABELS[type] || type;
}

export function txnSub(type, meta, referenceId, resolved) {
  if (type === "recharge") return referenceId ? `Razorpay · ${referenceId}` : "Razorpay";
  const phone = resolved?.to || meta?.to;
  const country = resolved?.country || meta?.country;
  const campaign = resolved?.campaign_name;
  if (type === "debit" || type === "refund") {
    const parts = [];
    if (campaign) parts.push(campaign);
    if (phone) parts.push(phone);
    if (country && country !== "DEF") parts.push(country);
    if (parts.length) return parts.join(" · ");
  }
  if (type === "refund" && meta?.reason === "utility_in_service_window") return "Utility (free 24h window)";
  if (type === "refund" && meta?.reason) return String(meta.reason).replace(/_/g, " ");
  if (type === "adjustment" && meta?.reason) return meta.reason;
  if (meta?.count) return `${meta.count} messages`;
  return referenceId || "—";
}
